import { NgModule } from '@angular/core';
import { PipeNewLine } from '../pipes/new-line.pipe';
import { Safe } from '../pipes/safe.pipe';

@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [
    PipeNewLine,
    Safe
  ],
  exports: [
    PipeNewLine,
    Safe
  ]
})
export class CoreModule { }
